declare global {
  interface Window {
    Intercom?: ((command: string, settings?: Record<string, unknown>) => void) & {
      q?: unknown[][]
    }
    intercomSettings?: Record<string, unknown>
  }
}

// Installs the Intercom stub queue so calls made before the async script loads
// are buffered — mirrors the official Intercom snippet.
const installIntercomStub = (appId: string) => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('reattach_activator')
    window.Intercom('update', window.intercomSettings)
    return
  }
  const stub = function (...args: unknown[]) { stub.q!.push(args) } as NonNullable<Window['Intercom']>
  stub.q = []
  window.Intercom = stub
  window.intercomSettings = { app_id: appId }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://widget.intercom.io/widget/${appId}`
  document.head.appendChild(script)
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const appId = config.public.intercomAppId as string | undefined

  if (!appId) {
    return
  }

  installIntercomStub(appId)
  // Boot hidden — launcher is shown only inside the authenticated default layout
  window.Intercom!('boot', { app_id: appId, hide_default_launcher: true })

  // Tell Intercom about every client-side navigation so it updates the
  // last-seen timestamp and shows/hides correctly on each page.
  const unregisterAfterEach = useRouter().afterEach(() => {
    window.Intercom!('update')
  })
  nuxtApp.hook('app:beforeUnmount', unregisterAfterEach)
})
